import React, { useEffect } from "react";

const chunkArray = (array, size) => {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
};

const positionForIndex = (i) => {
  const mod = i % 3;
  if (mod === 0) return "slide-left";
  if (mod === 1) return "slide-up";
  return "slide-right";
};

const ServiceCard = ({ item, position, index }) => (
  <article
    className={`core-card ${position}`}
    style={{ "--i": index }}
  >
    <div className="core-card-icon" aria-hidden="true">
      <i className={item.icon}></i>
    </div>
    <div className="core-card-body">
      <h3 className="core-card-title">{item.name}</h3>
      <p className="core-card-text">{item.text}</p>
    </div>
    <span className="core-card-arrow" aria-hidden="true"></span>
  </article>
);

export const LdServices = ({ data }) => {
  const line1 = data?.line ?? [];
  const line2 = data?.line2 ?? [];
  const line3 = data?.line3 ?? [];
  const line4 = data?.line4 ?? [];

  const allItems = [...line1, ...line2, ...line3, ...line4];
  const rows = chunkArray(allItems, 3);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    document
      .querySelectorAll("#services .core-card, #services .reveal")
      .forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [data]);

  return (
    <section id="services" className="text-center">
      <div className="container">
        <div className="services-head">
          <span className="services-eyebrow reveal">
            <span className="services-eyebrow-dot" aria-hidden="true"></span>
            Tudo em um só app
          </span>
          <h2 className="services-title reveal">
            Para você <span className="services-title-and">&amp;</span> para sua
            empresa
          </h2>
          <p className="services-subtitle reveal">
            Conta, Pix, crédito, investimentos, cobrança e pagamentos —
            soluções completas para o seu dia a dia financeiro.
          </p>
        </div>

        {rows.length === 0 ? (
          <div className="no-services">Nenhum serviço encontrado</div>
        ) : (
          <div className="core-cards-grid">
            {allItems.map((item, i) => (
              <ServiceCard
                key={`${item?.name || "service"}-${i}`}
                item={item}
                position={positionForIndex(i)}
                index={i}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
